import * as React from "react";
import { Button } from "../Button/Button";
import styles from "./Switch.module.scss";

export interface SwitchProps {
    // Switch to display
    switchOptions: {
        title: React.ReactNode;
        disabled?: boolean;
        onClick: (title: string) => void;
        key: string;
        hidden?: boolean;
        stat?: number;
    }[];
    // Current active switch
    activeSwitch: string;
}

export function Switch({ switchOptions, activeSwitch }: SwitchProps) {
    return (
        <div className={styles.container}>
            {switchOptions
                .filter((item) => !item.hidden)
                .map((button) => (
                    <Button
                        variant="normal"
                        className={`${styles.button} ${
                            button?.key === activeSwitch ||
                            activeSwitch === button.title
                                ? styles.active
                                : ""
                        }`}
                        key={button.key}
                        disabled={button.disabled}
                        onClick={() => button.onClick(button.key)}
                    >
                        {button.title}
                        {button.stat ? (
                            <span className={styles.stat}>{button.stat}</span>
                        ) : null}
                    </Button>
                ))}
        </div>
    );
}
